import Api from '../api';
import { ensureOk } from '../ensure_ok';
import { MonitoringPriority } from '../monitoring_settings';

export type MonitoringTestKind = 'email' | 'sound' | 'push';

export const sendMonitoringNotificationTest = (
  kind: MonitoringTestKind,
  companyId: number,
  priority?: MonitoringPriority,
) =>
  Api.post('/facilitadores/monitoring_notification_tests', { kind, companyId, priority }).then(
    ensureOk,
  );
